import { render, staticRenderFns } from "./project-document.vue?vue&type=template&id=2d2d581b"
import script from "./project-document.vue?vue&type=script&lang=js"
export * from "./project-document.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports